/**
 * The tutor sometimes writes markdown ("1) **Ball:** ..."), which children would see literally. Display only: paired
 * emphasis markers, heading hashes, inline code ticks and code fences come off; everything else is left exactly as
 * written - lone or in-word underscores (x_1, snake_case), multiplication (2 * 3, F=m*a) and maths stay (Sol
 * mobile-device-pass-2 D2 D: strip in both clients now, a plain-text tutor prompt later).
 */
export function plainReply(text) {
  if (!text || typeof text !== 'string') return text || '';
  return text
    .replace(/^```[^\n]*\n?/gm, '') // code fences
    .replace(/^#{1,6}[ \t]+/gm, '') // headings
    .replace(/\*\*(?=\S)([^*\n]*?\S)\*\*/g, '$1') // **bold**
    .replace(/(^|\s)\*\*(?=\S)/g, '$1') // a lone opening ** (a subtitle wipe left its partner behind)
    .replace(/(\S)\*\*(?=[\s.,!?;:)]|$)/g, '$1') // a lone closing **
    .replace(/(^|[^\w])__(?=\S)([^_\n]*?\S)__(?![\w])/g, '$1$2') // __bold__, not inside a word
    .replace(/(^|[\s(])\*(?=[^\s*])([^*\n]*?[^\s*])\*(?=[\s.,!?;:)]|$)/g, '$1$2') // *italic* between spaces
    .replace(/`([^`\n]+)`/g, '$1') // `code`
    .replace(/^[ \t]*[*-][ \t]+/gm, '• '); // list bullets
}

/**
 * Voice subtitles join a reply's lines before showing them, so plainReply never sees a line start there. Applies the
 * line-start rules (code fences, headings, bullets) to one streamed piece, given the text that came before it (Sol
 * markdown-device-check D1 D).
 */
export function plainPiece(piece, before = '') {
  if (!piece || typeof piece !== 'string') return piece || '';
  const lead = !before || /\n[ \t]*$/.test(before) ? '\n' : '';
  return (lead + piece)
    .replace(/\n[ \t]*```[^\n]*/g, '\n')
    .replace(/\n[ \t]*#{1,6}[ \t]+/g, '\n')
    .replace(/\n[ \t]*[*-][ \t]+/g, '\n• ')
    .slice(lead.length);
}
